<template>
  <v-dialog v-model="dialog" persistent scrollable max-width="640px">
    <v-card class="profile-dialog-card entity-form-dialog year-form-dialog">
      <div class="profile-dialog-header entity-form-dialog__header">
        <div class="entity-form-dialog__title">
          <v-avatar size="44" color="green lighten-5"><v-icon color="primary">mdi-calendar-plus</v-icon></v-avatar>
          <div><span>Academic year</span><h2>Create academic year</h2><p>Set the teaching period and report-card generation window.</p></div>
        </div>
        <v-btn icon aria-label="Close create year dialog" @click="close"><v-icon>mdi-close</v-icon></v-btn>
      </div>
      <v-divider />
      <v-card-text class="profile-dialog-body entity-form-dialog__body">
        <section class="entity-form-dialog__section">
          <div class="entity-form-dialog__section-heading">
            <span><v-icon size="19" color="primary">mdi-school-outline</v-icon></span>
            <div><h3>Year details</h3><p>Identify the year and the department it belongs to.</p></div>
          </div>
          <v-row>
            <v-col cols="12" sm="6"><v-text-field v-model="Year.name" outlined dense label="Year name *" placeholder="2026 - 2027" :error-messages="fieldErrors('name')" /></v-col>
            <v-col cols="12" sm="6"><v-autocomplete v-model="Year.ClassId" :items="Classes" item-text="name" item-value="id" outlined dense label="Department *" :loading="classesLoading" :error-messages="fieldErrors('ClassId')" /></v-col>
          </v-row>
        </section>
        <section class="entity-form-dialog__section">
          <div class="entity-form-dialog__section-heading">
            <span><v-icon size="19" color="primary">mdi-calendar-lock-outline</v-icon></span>
            <div><h3>Report-card window</h3><p>Generation locks automatically after the end date plus the grace period.</p></div>
          </div>
          <v-row>
            <v-col cols="12" sm="6"><v-text-field v-model="Year.startDate" type="date" outlined dense label="Start date *" :error-messages="fieldErrors('startDate')" /></v-col>
            <v-col cols="12" sm="6"><v-text-field v-model="Year.endDate" type="date" outlined dense label="End date *" :error-messages="fieldErrors('endDate')" /></v-col>
            <v-col cols="12"><v-text-field v-model.number="Year.reportCardLockDelayDays" type="number" min="0" max="90" outlined dense label="Report-card grace period (days) *" hint="Teachers and administrators can regenerate reports during this period. Default: 10 days." persistent-hint /></v-col>
          </v-row>
        </section>
        <section class="entity-form-dialog__section"><v-textarea v-model="Year.note" outlined rows="3" label="Internal notes" hide-details /></section>
      </v-card-text>
      <v-divider />
      <v-card-actions class="profile-dialog-actions entity-form-dialog__actions"><v-btn text @click="close">Cancel</v-btn><v-btn color="primary" depressed :loading="loading" @click="submit">Create year</v-btn></v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import yearService from "../service.js";
import classesService from "@/modules/Classes/service.js";
const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");

export default {
  name: "create-year",
  props: { createDialog: { default: false } },
  mixins: [validationMixin],
  data() { return { dialog: false, loading: false, classesLoading: false, Classes: [], Year: { name: null, ClassId: null, startDate: null, endDate: null, reportCardLockDelayDays: 10, note: null } }; },
  validations: { Year: { name: { required }, ClassId: { required }, startDate: { required }, endDate: { required } } },
  watch: { createDialog(val) { this.dialog = val; if (val) this.getClasses(); } },
  methods: {
    emptyYear() { return { name: null, ClassId: null, startDate: null, endDate: null, reportCardLockDelayDays: 10, note: null }; },
    fieldErrors(field) { if (!this.$v.Year[field].$dirty || this.$v.Year[field].required) return []; return ["This field is required"]; },
    close() { this.Year = this.emptyYear(); this.$v.$reset(); this.$emit("close"); },
    async getClasses() { this.classesLoading = true; try { const res = await classesService.getAll(); this.Classes = res.data || []; } finally { this.classesLoading = false; } },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid || (this.Year.startDate && this.Year.endDate && this.Year.startDate > this.Year.endDate)) return this.toast("error", "Please correct the highlighted fields");
      this.loading = true;
      try { await yearService.create(this.Year); this.toast("success", "Academic year created"); this.$emit("submit"); this.close(); }
      catch (error) { this.toast("error", error?.response?.data?.message || error?.data?.message || error.message || "Unable to create year"); }
      finally { this.loading = false; }
    },
    toast(icon, title) { this.$swal.mixin({ toast: true, position: "top-end", showConfirmButton: false, timer: 3000 }).fire({ icon, title }); },
  },
};
</script>
